import { useEffect, useRef, useState } from "react";
import {
  GoogleMap,
  StreetViewPanorama,
  useJsApiLoader,
} from "@react-google-maps/api";
import { Col } from "antd";
import MarkerItem from "./Components/MarkerItem";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store/Reducers";
import { useGetAdverts } from "../ListItems/ServerSideStates";
import {
  handleSetAdvertListFilter,
  handleSetMapCenter,
} from "../ListItems/ClientStates";
import { excludeFilterPropertiesOnRequest } from "helpers/ExcludeAdvertFilter";
import GeneralLoadingSpinner from "apps/Common/GeneralLoadingSpinner";

const containerStyle = {
  width: "100%",
  height: "100vh",
};

// Türkiye'nin coğrafi merkezi (Ankara yakınları)
const TURKEY_CENTER = {
  lat: 39.9334,
  lng: 32.8597
};

// Varsayılan zoom seviyesi (Türkiye'nin tamamını gösterir)
const DEFAULT_ZOOM = 6;

const MapLocationList = (props: any) => {
  const { filter, mapCenter } = useSelector(
    (state: RootState) => state.realState
  );
  const { selectedMarkerItemData } = useSelector(
    (state: RootState) => state.mapList
  );

  const [initialLoad, setInitialLoad] = useState(true);
  const adverts = useGetAdverts({
    ...excludeFilterPropertiesOnRequest(filter),
    PageSize: 1000,
  });
  
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAP_API || "",
    libraries: ["places"],
  });

  const mapRef = useRef<google.maps.Map | null>(null);
  const dispatch = useDispatch();

  useEffect(() => {
    // İlk yüklemede Türkiye merkezini ayarla
    if (initialLoad) {
      dispatch(handleSetMapCenter({ data: TURKEY_CENTER }));
      setInitialLoad(false);
    }

    // Veriler geldiğinde merkezi ilk ilana göre güncelle
    if (
      adverts?.data?.data?.data &&
      adverts.data.data.data.length > 0 &&
      !selectedMarkerItemData
    ) {
      const firstItem = adverts.data.data.data[0];
      const updatedCenter = {
        lat: Number(firstItem.latitude),
        lng: Number(firstItem.longitude),
      };
      dispatch(handleSetMapCenter({ data: updatedCenter }));
    }
  }, [adverts?.data?.data, initialLoad, selectedMarkerItemData]);

  return (
    <>
      {isLoaded ? (
        <Col span={24} className="!grid gap-2 mt-5">
          {(adverts.isLoading || adverts.isFetching) && (
            <GeneralLoadingSpinner />
          )}

          <div>
            <GoogleMap
              mapContainerStyle={containerStyle}
              center={initialLoad ? TURKEY_CENTER : mapCenter} // İlk yüklemede Türkiye merkezi
              zoom={initialLoad ? DEFAULT_ZOOM : 7} // İlk yüklemede geniş görünüm
              onLoad={(map) => {
                mapRef.current = map;
              }}
              onZoomChanged={() => {
                if (mapRef.current) {
                  const zoomLevel: any = mapRef.current.getZoom();
                  const newCenter = mapRef.current.getCenter();
                  let updatedCenter = { lat: 0, lng: 0 };
                  if (newCenter) {
                    updatedCenter = {
                      lat: newCenter.lat(),
                      lng: newCenter.lng(),
                    };
                  }

                  if (!selectedMarkerItemData || zoomLevel > 7) {
                    dispatch(handleSetMapCenter({ data: updatedCenter }));
                    dispatch(
                      handleSetAdvertListFilter({
                        filter: {
                          ...filter,
                          SelectedLat: updatedCenter.lat,
                          SelectedLng: updatedCenter.lng,
                        },
                      })
                    );
                  }
                }
              }}
            >
              <>
                {adverts?.data?.data?.data
                  ? adverts.data.data?.data
                      .filter((item: any) => item?.latitude && item?.longitude)
                      .map((item: any, index: number) => (
                        <MarkerItem key={index} item={item} />
                      ))
                  : []}
              </>
              <StreetViewPanorama
                options={{
                  position: mapCenter,
                  pov: {
                    heading: 100,
                    pitch: 0,
                  },
                  zoom: 1,
                }}
              />
            </GoogleMap>
          </div>
        </Col>
      ) : (
        <p>Harita yükleniyor</p>
      )}
    </>
  );
};

export default MapLocationList;